import produce from 'immer';
import { State, Actions } from './interfaces';
import {
  GET_ORDERS,
  GET_ORDERS_SUCCESS,
  GET_ORDERS_FAILED,
  GET_ORDER_WITH_ID,
  GET_ORDER_WITH_ID_SUCCESS,
  GET_ORDER_WITH_ID_FAILED,
  ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED,
  ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS,
  ACTION_RETRIEVE_RUBIKA_ORDERS,
  SCHEDULE_ORDERS,
  SCHEDULE_ORDERS_SUCCESS,
  SCHEDULE_ORDERS_FAILED,
  GET_LOGS,
  GET_LOGS_SUCCESS,
  GET_LOGS_FAILED,
  GET_ALL_ORDERS,
  GET_ALL_ORDERS_SUCCESS,
  GET_ALL_ORDERS_FAILED,
} from './constants';

export const initialState: State = {
  ordersList: [],
  allOrders: [],
  order: {},
  logs: [],
  bundleAssignment: [],
  count: 0,
  loading: false,
  error: '',
};

export const OrdersReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_ORDERS:
        draft.loading = true;
        break;
      case GET_ORDERS_SUCCESS:
        draft.ordersList = action.data;
        draft.allOrders = [];
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;
      case GET_ORDER_WITH_ID:
        draft.loading = true;
        break;
      case GET_ORDER_WITH_ID_SUCCESS:
        draft.order = action.data;
        draft.loading = false;
        break;
      case GET_ORDER_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case ACTION_RETRIEVE_RUBIKA_ORDERS:
        draft.loading = true;
        break;
      case ACTION_RETRIEVE_RUBIKA_ORDERS_SUCCESS:
        draft.loading = false;
        break;
      case ACTION_RETRIEVE_RUBIKA_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case SCHEDULE_ORDERS:
        draft.loading = true;
        break;
      case SCHEDULE_ORDERS_SUCCESS:
        draft.bundleAssignment = action.data;
        draft.loading = false;
        break;
      case SCHEDULE_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_LOGS:
        draft.loading = true;
        break;
      case GET_LOGS_SUCCESS:
        draft.logs = action.data;
        draft.loading = false;
        break;
      case GET_LOGS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_ALL_ORDERS:
        draft.loading = true;
        break;
      case GET_ALL_ORDERS_SUCCESS:
        draft.allOrders = action.data;
        draft.loading = false;
        break;
      case GET_ALL_ORDERS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      default:
        break;
    }
  });
export default OrdersReducer;
